export default __webpack_public_path__ + "static/media/photo--lg--alaina-2.cad57cd7.jpg";